export default __webpack_public_path__ + "static/assets/7efe82fffae735cd083388badd51b3fa.svg";